var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGarbage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 2.303h-3.328V1.76c0-.97-.79-1.76-1.76-1.76H6.418c-.97 0-1.76.79-1.76 1.76v.543h-3.33a.442.442 0 00-.443.444c0 .246.197.444.444.444h.802v10.434A2.378 2.378 0 004.506 16h6.987a2.378 2.378 0 002.375-2.375V3.191h.803a.442.442 0 00.444-.444.442.442 0 00-.444-.444zM5.547 1.76c0-.48.391-.872.872-.872h3.164c.48 0 .872.392.872.872v.543H5.546V1.76zm7.434 11.865a1.49 1.49 0 01-1.487 1.487H4.506a1.49 1.49 0 01-1.486-1.487V3.191h9.963v10.434h-.003z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.52a.442.442 0 00.444-.444V5.227A.442.442 0 008 4.783a.442.442 0 00-.444.444v7.846c0 .246.197.447.444.447zM5.102 13.03a.442.442 0 00.444-.445V5.714a.442.442 0 00-.444-.444.442.442 0 00-.444.444v6.871c0 .247.2.444.444.444zM10.898 13.03a.442.442 0 00.444-.445V5.714a.442.442 0 00-.444-.444.442.442 0 00-.444.444v6.871c0 .247.197.444.444.444z",
    fill: "#9F9F9F"
  })));
}

export default __webpack_public_path__ + "./fonts/garbage.3c3563ef2be543e329ad91d4ced53519.svg";
export { SvgGarbage as ReactComponent };